import { useEffect } from 'react';

export const useCloseOnOutsideClick = ({ ref, open, setOpen }) => {
  useEffect(() => {
    if (!open) {
      return;
    }
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, ref, setOpen]);
};
